<script>
    import { Scatter } from 'vue-chartjs'
    import { ChartRegressions } from 'chartjs-plugin-regression'
    import watermark from '@images/QUEL_logo_watermark.png'

    export default {
        data () {
            return {
                useWatermark: true,
                chartOptions: Object,
                axisBounds: {
                    xMin: null,
                    yMin: null,
                    xMax: null,
                    yMax: null,
                },
                watermarkImg: null,
            }
        },
        created() {
            this.watermarkImg = new Image();
            this.watermarkImg.src = watermark;
        },
        mounted() {
            this.addPlugin({
                id: 'watermark',
                afterDraw: () => {
                    if(this.useWatermark) {
                        let ctx = this.$refs.canvas.getContext("2d");
                        let watermarkSize = ctx.canvas.clientHeight/6.5;
                        ctx.drawImage(this.watermarkImg, 0, ctx.canvas.clientHeight*0.925, (watermarkSize/2)*2.67, watermarkSize/2)
                    }
                }
            })
        },
        methods: {
            getDatasetBounds() {
                // gets bound values for axes
                let offset = 0.1;
                let axis = 'x';
                for(let i = 0; i < 2; i++) {
                    // gets smallest values for bounds of dataset
                    let min = Infinity;
                        this.graphData.datasets[0].data.forEach((elem) => {
                        if (elem[axis] < min) {
                            min = elem[axis];
                        }
                    })
                    // this.axisBounds[`${axis}Min`] = Math.round((min - (min*offset))*1000)/1000;
                    this.axisBounds[`${axis}Min`] = (min - (min*offset)).toFixed(3);
                    

                    // gets largest values for bounds of dataset
                    let max = 0;
                    this.graphData.datasets[0].data.forEach((elem) => {
                        if (elem[axis] > max) {
                            max = elem[axis];
                        }
                    })
                    if(axis == 'y'){
                        this.axisBounds[`${axis}Max`] = Math.ceil((max + (max*offset)));
                    } else {
                        // this.axisBounds[`${axis}Max`] = Math.round((max + (max*offset))*1000)/1000;
                        this.axisBounds[`${axis}Max`] = (max + (max*offset)).toFixed(3);
                    }
                    axis = 'y';
                }
                if (this.chartSettings.axisBounds.xMin !== null) { this.axisBounds.xMin = this.chartSettings.axisBounds.xMin }
                else { this.axisBounds.xMin = parseInt(this.axisBounds.xMin) }
                if (this.chartSettings.axisBounds.xMax !== null) { this.axisBounds.xMax = this.chartSettings.axisBounds.xMax }
                else { this.axisBounds.xMax = parseInt(this.axisBounds.xMax) }
                if (this.chartSettings.axisBounds.yMin !== null) { this.axisBounds.yMin = this.chartSettings.axisBounds.yMin }
                else { this.axisBounds.yMin = parseInt(this.axisBounds.yMin) }
                if (this.chartSettings.axisBounds.yMax !== null) { this.axisBounds.yMax = this.chartSettings.axisBounds.yMax }
                else { this.axisBounds.yMax = parseInt(this.axisBounds.xyMax) }
            },
            getChartOptions() {
                this.chartOptions = {
                    legend: {
                        display: false,                        
                    },
                    title: {
                        display: true,
                        text: this.chartSettings.title,
                        position: 'top',
                        fontSize: this.fontSize
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'nearest',
                        bodyFontSize: (this.fontSize <= 14) ? this.fontSize : 20,
                        footerFontSize: (this.fontSize <= 14) ? this.fontSize-2 : 18,
                        callbacks: {
                            label: (tooltipItem, data) => {
                                let textBlock = [];
                                let label = data.datasets[tooltipItem.datasetIndex].label || '';          
                                if (label) {
                                    textBlock.push(label);
                                }
                                
                                return textBlock;
                            },
                            footer: (tooltipItem, data) => {
                                let textBlock = [];
                                let xLabels = this.chartSettings.xAxisLabel.split(' ');
                                let yLabels = this.chartSettings.yAxisLabel.split(' ');
                                textBlock.push(`${xLabels[0]}: ${tooltipItem[0].xLabel.toFixed(3)} ${xLabels[1].replace('(', '').replace(')', '')}`);
                                textBlock.push(`${yLabels[0]}: ${tooltipItem[0].yLabel.toFixed(3)} ${yLabels[1].replace('(', '').replace(')', '')}`);
                                return textBlock;
                            },
                            labelColor: (point) => {
                                return {
                                    borderColor: '',
                                    backgroundColor: this.graphData.datasets[point.datasetIndex].backgroundColor
                                };
                            },
                        },
                    },
                    scales: {
                        xAxes: [{
                            type: this.chartSettings.xAxisScale,
                            scaleLabel: {
                                display: true,
                                labelString: this.chartSettings.xAxisLabel,
                                fontSize: this.fontSize,
                                fontStyle: 'bold',
                            },
                            ticks: {
                                // beginAtZero: false,
                                min: this.axisBounds.xMin,
                                max: this.axisBounds.xMax,
                                autoSkip: true,
                                fontSize: this.fontSize,
                                stepSize: this.chartSettings.stepSize,
                                callback: function(value, index, values) {
                                    return value;
                                }
                            },
                            afterBuildTicks: (chart) => {
                                if(this.ticks.length > 0) {
                                    chart.ticks = this.ticks;
                                }
                            }
                        }],
                        yAxes: [{
                            type: this.chartSettings.yAxisScale,
                            scaleLabel: {
                                display: true,
                                labelString: this.chartSettings.yAxisLabel,
                                fontSize: this.fontSize,
                                fontStyle: 'bold',
                            },
                            ticks: {
                                // beginAtZero: true,
                                min: this.axisBounds.yMin,
                                max: this.axisBounds.yMax,
                                fontSize: this.fontSize,
                                autoSkip: true,
                        
                                // // callback: changes scientific notation to regular
                                // callback: function(...args) {
                                //     const value = Chart.Ticks.formatters.logarithmic.call(this, ...args);
                                //     if (value.length) {
                                //         return Number(value).toLocaleString()
                                //     }
                                //     return value;
                                // }
                            }
                        }],
                    },
                    responsive: this.responsive,
                    maintainAspectRatio: false,
                };
            }
        },
        extends: Scatter,
        props: {
            graphData: null,
            chartSettings: Object,
            ticks: Array,
            responsive: Boolean,
            fontSize: Number,
        },
        watch: {
            graphData: function() {
                if(this.graphData != null){
                    this.getDatasetBounds();
                    this.getChartOptions();
                    this.renderChart(this.graphData, this.chartOptions);
                    let regressionResults = {
                        graphData: this.$data._chart,
                        regressions: ChartRegressions,
                    }
                    this.$emit('onCompleteRegression', regressionResults);
                }
            },
            chartData () {
                this.$data._chart.update()
            },
            '$refs.canvas': {
                handler: () => {
                    console.log("something changed!");
                }
            }
        }
    }
</script>

<style>
</style>
